(ns ycweb.app.admin.tasks.views.grid
  (:require
   [ycweb.app.admin.tasks.forms.incident]
   [ycweb.app.admin.tasks.forms.devtask]
   [ycweb.app.admin.tasks.common :as yaatc.common]))

(def tasks-table-fns
  {:config-fns
   {:filter-rows yaatc.common/filter-tasks}
   :column-fns
   {:task-uid-cell-fn yaatc.common/task-uid-cell
    :person-cell-fn yaatc.common/person-cell
    :multi-person-cell-fn yaatc.common/multi-person-cell
    :status-fn yaatc.common/status}})

(def task-grid-columns
  [{:key :ent/uuid
    :render
    {:render-k :task-uid-cell-fn}
    :title "UID"}
   {:key :ent/display-name
    :title "Title"}
   {:key [:task/team :ent/display-name]
    :title "Team"}
   {:key [:task/type]
    :sorting-key [:task/type :ent/sort-order]
    :title "Type"
    :render
    {:render-k :status-fn}}
   {:key [:task/stream]
    :sorting-key [:task/stream :ent/display-name]
    :title "Stream"
    :render
    {:render-k :status-fn}}
   {:key [:task/product]
    :sorting-key [:task/product :ent/sort-order]
    :title "Product"
    :render
    {:render-k :status-fn}}
   {:key :task/budget
    :title "Budget"
    :align-class :u-text-right}
   {:key :task/time-spent
    :title "Time Spent"
    :align-class :u-text-right}
   {:key [:task/assigned]
    :sorting-key [:task/assigned :ent/display-name]
    :title "Assigned"
    :render
    {:render-k :multi-person-cell-fn}}
   {:key [:task/requestor]
    :sorting-key [:task/requestor :ent/display-name]
    :title "Requestor"
    :render
    {:render-k :person-cell-fn}}
   {:key [:task/team-status]
    :sorting-key [:task/team-status :ent/sort-order]
    :title "Team Status"
    :render
    {:render-k :status-fn}}
   {:key [:task/dev-status]
    :sorting-key [:task/dev-status :ent/sort-order]
    :title "Action Status"
    :render
    {:render-k :status-fn}}
   {:key :airtable/date-created
    :type :date
    :title "Created"}])

(def tasks-table-config
  {:table-name :admin.tasks/list
   :row-id :ent/uuid
   :options
   {:order :asc
    :sticky-header? true
    :paging? true
    :pagination {:page 0 :page-size 15}
    :filter :filter-rows}
   :data-source
   {:cursor [:admin.tasks :tasks]
    :schema :admin.tasks/schema}
   :column-defs task-grid-columns})